import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import swal from 'sweetalert';

import { Row, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/Card";


import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";


const MasterDealSmithForm = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [getDSdata, setgetDSdata, getDSdataRef] = useStateRef();

  const [errors, setErrors] = useState({});

  // <---variable declaration from API  responce--->
  const [accountCode, setAccountCode, accountCodeRef] = useStateRef('');
  const [place, setPlace, placeRef] = useStateRef('');
  const [address, setAddress, addressRef] = useStateRef('');
  const [delivery, setDelivery, deliveryRef] = useStateRef('');
  const [phoneno, setPhoneno, phonenoRef] = useStateRef('');
  const [mobileno, setMobileno, mobilenoRef] = useStateRef('');
  const [contactname, setContactname, contactnameRef] = useStateRef('');
  const [gcode, setGcode, gcodeRef] = useStateRef('');
  const [deptcode, setDeptcode, deptcodeRef] = useStateRef('');
  const [crwt, setCrwt, crwtRef] = useStateRef('');
  const [dbwt, setDbwt, dbwtRef] = useStateRef('');
  const [goldbar, setGoldbar, goldbarRef] = useStateRef('');
  const [active, setActive, activeRef] = useStateRef(true);
  const [DueDays, setDueDays, DueDaysRef] = useStateRef('');
  const [seal, setSeal, sealRef] = useStateRef('');
  const [pactive, setPactive, pactiveRef] = useStateRef('');
  const [billparty, setBillparty, billpartyRef] = useStateRef('');
  const [msgmobileno, setMsgmobileno, msgmobilenoRef] = useStateRef('');
  const [sms, setSms, smsRef] = useStateRef('');
  const [accountname, setAccountname, accountnameRef] = useStateRef('');
  const [accountNo, setAccountNo, accountNoRef] = useStateRef('');
  const [panNo, setPanNo, panNoRef] = useStateRef('');
  const [dsId, setDsId, dsIdRef] = useStateRef('');
  const [gst, setGst, gstRef] = useStateRef('');
  const [isEdit, setIsEdit] = useStateRef(false);


  const [NewElg, setNewElg] = useState(false);
  //const [EditVal, setEditVal] = useState(false);
  const [btndisabled, setDisabled] = useState('disabled');
  useEffect(() => {
debugger;
      setNewElg(Boolean(sessionStorage.getItem("dealSmith_NewElg")));
      
      if (sessionStorage.getItem("dealSmith_EditElg")=="true"){
        setDisabled('');
      }
      else
      {
        setDisabled('disabled');
      }

    innitialSetValue();
    setAccountCode("")
  
    if (sessionStorage.getItem("accountsmasterId") != "0") {
      setIsEdit(true);
      getDealersmithWithId();
    }
    else setIsEdit(false);

  }, []);

  function innitialSetValue() {
    setAccountCode("");
  }

  const validateForm = () => {
    const newErrors = {};

    if (!accountname) {
      newErrors.accountname = 'Account Name is required';
    }
    if (!gcode) {
      newErrors.gcode = 'Account Name is required';
    }

    if (!address) {
      setAddress('-');
    }
    if (!deptcode) {
      newErrors.deptcode = 'Account Name is required';
    }
    
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addDealersmith = (e) => {
    
    const isFormValid = validateForm();

    if (isFormValid) {
      insertDealersmith();
      swal({

        title: "Success",
        text: "Successfully Add Your Details!",
        icon: "success",
        button: "Ok"

      }).then(function () {
        navigate('/dashboard/table/table-data-dealSmith');
      });
    }


  }

  const updateDealerSmith = (e) => {

    updateDealersmith();
    swal({

      title: "Success",
      text: "Successfully Updated Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      navigate('/dashboard/table/table-data-dealSmith');
    });


  }

  async function getDealersmithWithId() {
    try {
      let postData = {
        PageNumber: "1",
        RowspPage: "1",
        UserId: "0",
        accountsmasterId: sessionStorage.getItem("accountsmasterId"),
        Search:""
      }
      const results = await apiService.postCall(apiPath.master.get.getDealerSmith, postData);
      if (results != "-1") {

        

        setAccountCode(results?.data?.[0]?.[0].AccCode);
        setPlace(results?.data?.[0]?.[0].Place);
        setAddress(results?.data?.[0]?.[0].Address1);
        setDelivery(results?.data?.[0]?.[0].DelAddress1);
        setPhoneno(results?.data?.[0]?.[0].Phoneno);
        setMobileno(results?.data?.[0]?.[0].Cellno);
        setContactname(results?.data?.[0]?.[0].ContactName);
        setGcode(results?.data?.[0]?.[0].GCode);
        setDeptcode(results?.data?.[0]?.[0].DeptCode);
        setCrwt(results?.data?.[0]?.[0].CreditWt);
        setDbwt(results?.data?.[0]?.[0].DebitWt);
        setGoldbar(results?.data?.[0]?.[0].GoldBar);
        setActive(results?.data?.[0]?.[0].Active);
        setDueDays(results?.data?.[0]?.[0].DueDays);
        setSeal(results?.data?.[0]?.[0].Seal);
        setPactive(results?.data?.[0]?.[0].PActive);
        setBillparty(results?.data?.[0]?.[0].BillParty);
        setMsgmobileno(results?.data?.[0]?.[0].AccCode);
        setSms(results?.data?.[0]?.[0].sms);
        setAccountname(results?.data?.[0]?.[0].AccDesc);
        setAccountNo(results?.data?.[0]?.[0].AccountNo);
        setPanNo(results?.data?.[0]?.[0].PANNo);
        setDsId(results?.data?.[0]?.[0].Id);
        setGst(results?.data?.[0]?.[0].GSTNo)

        console.log(results?.data?.[0]?.[0], "<--check2");

      }
    } catch (error) {
      console.log(error);
    }
  }

  async function insertDealersmith() {
    try {
      let postData = {

        "accdesc": document.getElementById("accdesc").value,
        "place": document.getElementById("place").value,
        "deladdress1": document.getElementById("Daddress").value,
        "address1": document.getElementById("addresss").value,
        "phoneno": document.getElementById("phoneno").value,
        "mobileno": document.getElementById("mobileno").value,
        "email": "-",
        "shortdesc": "-",
        "contactname": document.getElementById("contactname").value,
        "website": "-",
        "accountno": document.getElementById("accountno").value,
        "panno": document.getElementById("panno").value,
        "gcode": Number(document.getElementById("gcode").value),
        "deptcode": Number(document.getElementById("deptcode").value),
        "crwt": Number(document.getElementById("crwt").value),
        "dbwt": Number(document.getElementById("dbwt").value),
        "goldbar": document.getElementById("goldbar").checked,
        "active": document.getElementById("active").checked,
        "DueDays": Number(document.getElementById("DueDays").value),
        "seal": document.getElementById("seal").value,
        "pactive": document.getElementById("pactive").checked,
        "billparty": document.getElementById("billparty").checked,
        "msgmobileno": document.getElementById("msgmobileno").value,
        "gstno": document.getElementById("gst").value,
        "sms": document.getElementById("sms").checked


      }
      const results = await apiService.insertDealersmith(apiPath.master.insert.insertDealersmith, postData);
      debugger
      if (results != "-1") {
        console.log(results, "result insert");
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function updateDealersmith() {
    try {
      let postData = {

        "accdesc": document.getElementById("accdesc").value,
        "place": document.getElementById("place").value,
        "deladdress1": document.getElementById("Daddress").value,
        "address1": document.getElementById("addresss").value,
        "phoneno": document.getElementById("phoneno").value,
        "mobileno": document.getElementById("mobileno").value,
        "email": "-",
        "shortdesc": "-",
        "contactname": document.getElementById("contactname").value,
        "website": "-",
        "accountno": document.getElementById("accountno").value,
        "panno": document.getElementById("panno").value,
        "gcode": Number(document.getElementById("gcode").value),
        "deptcode": Number(document.getElementById("deptcode").value),
        "crwt": Number(document.getElementById("crwt").value),
        "dbwt": Number(document.getElementById("dbwt").value),
        "goldbar": document.getElementById("goldbar").checked,
        "active": document.getElementById("active").checked,
        "DueDays": Number(document.getElementById("DueDays").value),
        "seal": document.getElementById("seal").value,
        "pactive": document.getElementById("pactive").checked,
        "billparty": document.getElementById("billparty").checked,
        "msgmobileno": document.getElementById("msgmobileno").value,
        "gstno": document.getElementById("gst").value,
        "sms": document.getElementById("sms").checked,
        "id": Number(dsId),

      }
      const results = await apiService.updateDealersmith(apiPath.master.update.updateDealersmith, postData);
    } catch (error) {
      console.log(error);
    }
  }
  const navigate = useNavigate();
  const BactToTableDealSmith = () => {
    navigate('/dashboard/table/table-data-dealSmith');
  };

  return (
    <>
      <Row>
        <Card>

          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Supplier Master</h4>
            </div>
          </Card.Header>

          <Card.Body >
            <div className='container-fluid'>

              <div className='row'>

                <div className='col-md-6 col-lg-6'>
                  <div className='mb-3'>
                    <Form.Label>Account Code</Form.Label>
                    <Form.Control type="text" value={accountCode} disabled={true} />
                  </div>
                  <div className='mb-3'>
                    <Form.Label>Account Group</Form.Label>
                    <Form.Control type="text" value="Creditor Store" disabled={true} />
                  </div>

                  <div className='mb-3'>
                    <Form.Label>Account Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="text"
                      placeholder=""
                      value={accountname} id='accdesc' onChange={(e) => setAccountname(e.target.value)} isInvalid={!!errors.accountname} />

                  </div>

                  <div className='mb-3'>
                    <Form.Label>Group <span className="text-danger">*</span></Form.Label>
                    <select className="form-select" id="gcode" value={gcode} onChange={(e) => setGcode(e.target.value)} isInvalid={!!errors.gcode} disabled={sessionStorage.getItem("accountsmasterId") === dsId ? true : false}   >
                      <option value="" >Select Option</option>
                      <option value={0}>NONE</option>
                      <option value={1}>SMITH</option>
                      <option value={2}>DEALER</option>
                      <option value={3}>SMITH AND DEALER</option>
                    </select>
                  </div>

                  <div className='mb-3'>
                    <Form.Label>Metal <span className="text-danger">*</span></Form.Label>
                    <select className="form-select" id="deptcode" value={deptcode} onChange={(e) => setDeptcode(e.target.value)} isInvalid={!!errors.deptcode} disabled={sessionStorage.getItem("accountsmasterId") === dsId ? true : false}>
                      <option value="" >Select Option</option>
                      <option value={1}>Gold</option>
                      <option value={2}>Silver</option>
                      <option value={3}>Gold and Silver</option>
                    </select>
                  </div>

                  <div className='mb-3'>
                    <Form.Label>Place <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" id='place' value={place} placeholder=""  onChange={(e) => setPlace(e.target.value)} />
                  </div>

                  <div className='mb-3'>
                    <Form.Label>Address <span className="text-danger"></span></Form.Label>
                    <Form.Control as="textarea" id="addresss" rows="3" value={address}  onChange={(e) => setAddress(e.target.value)} />
                  </div>

                  <div className='mb-3'>
                    <div className='row'>
                      <div className=' col-md-6 mb-3'  hidden='hidden'>
                        <Form.Label>Opening Credit</Form.Label>
                        <Form.Control type="text" placeholder="" />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <Form.Label>O.Cr.Wt <span className="text-danger"></span></Form.Label>
                        <Form.Control type="text" placeholder="" id='crwt' value={crwt}  onChange={(e) => setCrwt(e.target.value)} />
                      </div>
                      <div className=' col-md-6 mb-3'  hidden='hidden'>
                        <Form.Label>Opening Debit </Form.Label>
                        <Form.Control type="text" placeholder="" />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <Form.Label>O.Dr.Wt <span className="text-danger"></span></Form.Label>
                        <Form.Control type="text" placeholder="" value={dbwt} id='dbwt'  onChange={(e) => setDbwt(e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 col-lg-6'>
                  <div className='mb-3' hidden='hidden'>
                    <Form.Label htmlFor="accountno"  >Account No <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="Enter No" id="accountno" value={accountNo} onChange={(e) => setAccountNo(e.target.value)} required />
                  </div>
                  <div className='mb-3'>
                    <Form.Label htmlFor="contactname">Contact Person <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="" value={contactname}  onChange={(e) => setContactname(e.target.value)} id="contactname" required />
                  </div>
                  <div className='mb-3'  hidden='hidden'>
                    <Form.Label htmlFor="mobileno">Cell No <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="Enter Cell No" value={mobileno}  onChange={(e) => setMobileno(e.target.value)} id="mobileno" required />
                  </div>
                  <div className='mb-3'>
                    <Form.Label htmlFor="phoneno">Mobile No <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="" value={phoneno}  onChange={(e) => setPhoneno(e.target.value)} id="phoneno" required />
                  </div>
                  <div className='mb-3'  hidden='hidden'>
                    <Form.Label htmlFor="panno">PAN No <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="" value={panNo}  onChange={(e) => setPanNo(e.target.value)} id="panno" required />
                  </div>
                  <div className='mb-3'>
                    <Form.Label htmlFor="msgmobileno">MSG MOB No <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" placeholder="" value={msgmobileno}  onChange={(e) => setMsgmobileno(e.target.value)} id="msgmobileno" required />
                  </div>
                  <div className='mb-3'  hidden='hidden'>
                    <Form.Label htmlFor="Daddress">Delivery Address <span className="text-danger"></span></Form.Label>
                    <Form.Control as="textarea" rows="3" value={delivery}  onChange={(e) => setDelivery(e.target.value)} id="Daddress" required />
                  </div>
                  <div className='mb-3'>
                    <div className='row'>
                      <div className=' col-md-4 ' hidden='hidden'>
                        <Form.Label htmlFor="Tds">TDS% <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" placeholder="Enter TDS%" id="Tds" required />
                      </div>
                      <div className='col-md-4'>
                        <Form.Label htmlFor="seal">Seal <span className="text-danger"></span></Form.Label>
                        <Form.Control type="text" value={seal} placeholder="" onChange={(e) => setSeal(e.target.value)} id="seal" required />
                      </div>
                      <div className='col-md-4'>
                        <Form.Label htmlFor="DueDays">Due Days <span className="text-danger"></span></Form.Label>
                        <Form.Control type="text" value={DueDays} placeholder="" onChange={(e) => setDueDays(e.target.value)} id="DueDays" required />
                      </div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <Form.Label>GST NO <span className="text-danger"></span></Form.Label>
                    <Form.Control type="text" value={gst}  onChange={(e) => setGst(e.target.value)} id="gst" required />
                  </div>
                </div>

                <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                  <div className='row'>
                    <div className='col-md-2 mb-3'>
                      <Form.Check.Input type="checkbox" className="me-2" id='goldbar' onChange={(e) => setGoldbar(e.target.checked)} checked={goldbar} />
                      <Form.Check.Label>Gold Bar</Form.Check.Label>
                    </div>
                    <div className='col-md-2 mb-3'>
                      <Form.Check.Input type="checkbox" className="me-2" id='active' onChange={(e) => setActive(e.target.checked)} checked={active} />
                      <Form.Check.Label>Active <span className="text-danger">*</span></Form.Check.Label>
                    </div>
                    <div className='col-md-2 mb-3'>
                      <Form.Check.Input type="checkbox" className="me-2" id='pactive' onChange={(e) => setPactive(e.target.checked)} checked={pactive} />
                      <Form.Check.Label>Print</Form.Check.Label>
                    </div>
                    <div className='col-md-2 mb-3' HIDDEN='hidden'>
                      <Form.Check.Input type="checkbox" className="me-2" id='billparty' onChange={(e) => setBillparty(e.target.checked)} checked={billparty} />
                      <Form.Check.Label>Bill Party</Form.Check.Label>
                    </div>
                    <div className='col-md-2 mb-3'>
                      <Form.Check.Input type="checkbox" className="me-2" id='sms' onChange={(e) => setSms(e.target.checked)} checked={sms} />
                      <Form.Check.Label>SMS</Form.Check.Label>
                    </div>
                  </div>
                </div>

              </div>

              <div style={{ direction: 'rtl' }}>
                <Form.Group className="form-group">


               
                  {
                    isEdit && <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={() => updateDealerSmith('')}>Update</Button>
                  }
                

                  {
                    !isEdit && NewElg &&  <Button type="button" variant="btn btn-primary" onClick={() => addDealersmith()}>Save</Button>
                  }

                  {' '}




                  <Button className='mr-5' type="button" variant="btn btn-danger" onClick={BactToTableDealSmith}>cancel</Button>

                </Form.Group>
              </div>

            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default MasterDealSmithForm;

